import { AjaxStub, ErrorStub, AjaxEventHandler } from '@bingads-webui/instrumentation-stubs';
import { isInternalUrl } from '@bingads-webui/url-util';
import _ from 'underscore';
import { ExpectedUnhandledPromiseErrors } from './expected-unhandled-promise-errors';

export function setStub({
  instrumentation,
  pageTrackingId,
  errorMappers,
  objectsToStub,
  ajaxStubOptions,
  lcid,
  serverContext,
}) {
  // If the application pulls in jQuery, stub it for ajax call.
  const filteredObjectsToStub = _.compact(objectsToStub);
  if (!_.isEmpty(filteredObjectsToStub)) {
    const shouldAddHeaders = ajaxContext => isInternalUrl(ajaxContext.url);
    const eventHandler = new AjaxEventHandler({ errorMappers, shouldAddHeaders });
    const ajaxStub = new AjaxStub({
      stubOptions: {
        filteredObjectsToStub,
        pageTrackingId,
        lcid,
        ajaxStubOptions,
      },
      eventHandler,
      instrumentation,
    });

    ajaxStub.init();
  }

  const isExpectedUnhandledPromiseError = errorMessage => _.some(
    ExpectedUnhandledPromiseErrors,
    promiseError => errorMessage && errorMessage.toLowerCase().indexOf(promiseError) > -1
  );

  const logUnhandledPromiseRejections = serverContext && serverContext.DynamicPermissions &&
  serverContext.DynamicPermissions.EnableLoggingForUnhandledPromiseRejections;

  const errorStub = new ErrorStub({
    instrumentation,
    logUnhandledPromiseRejections,
    isExpectedUnhandledPromiseError,
  });
  errorStub.init();
}
